import React from "react";

const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function numberToWords(n) {
  const num = parseInt(n, 10);
  if (!n || isNaN(num) || num < 0) return "";
  if (num === 0) return "Zero";
  if (num < 20) return ones[num];
  if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "");
  if (num < 1000) return ones[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " " + numberToWords(num % 100) : "");
  return num.toString();
}

export default function SickLeaveForm({
  formData,
  onChange,
  onQuickFillDays,
  isViewOnly,
  diagnosisSearch,
  onDiagnosisSearchChange,
  showDiagnosisDropdown,
  filteredDiagnosisOptions,
  onDiagnosisSelect,
  onDiagnosisDropdownToggle,
  onDiagnosisTextChange,
  shouldDisableField,
  getFieldStyle,
}) {
  const handleDaysFiguresChange = (value) => {
    onChange("noOfDaysOffFigures", value);
    onChange("noOfDaysOffWords", numberToWords(value));
  };

  return (
    <div className="row g-2 sickLeaveForm">
      <style>{`
        .sickLeaveForm .form-control,
        .sickLeaveForm .form-select {
          font-size: 12px;
          height: 32px;
          padding: 4px 10px;
        }
        .sickLeaveForm textarea.form-control {
          height: auto;
        }
        .sickLeaveForm .form-check-input {
          width: 14px;
          height: 14px;
        }
        .sickLeaveForm .form-check-label {
          font-size: 12px;
        }
      `}</style>
      {!isViewOnly && onQuickFillDays && (
        <div className="col-12 mb-1">
          <div className="d-flex flex-column align-items-center justify-content-center border rounded py-2 px-2" style={{ background: "#fff" }}>
            <span className="text-muted mb-1" style={{ fontSize: 11 }}>Quick Fill</span>
            <div className="btn-group" role="group">
              {[1, 2, 3].map((days) => (
                <button
                  key={days}
                  type="button"
                  className="btn btn-sm"
                  style={{ fontSize: 12, color: "#7A5C00", border: "1px solid #7A5C00", background: "#fff" }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "#7A5C00"; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#7A5C00"; }}
                  onClick={() => onQuickFillDays(days)}
                >
                  {days} Day{days > 1 ? "s" : ""}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Patient Information */}
      <div className="col-12 mt-1">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Patient Information</h6>
      </div>
      {formData.certificateRegistrationNo && (
        <div className="col-12">
          <label className="form-label mb-0" style={{ fontSize: 11 }}>Certificate Registration No.</label>
          <input
            type="text"
            className="form-control form-control-sm"
            value={formData.certificateRegistrationNo}
            readOnly
            style={{ background: "#f8f9fa", fontWeight: "bold", color: "#0d6efd" }}
          />
        </div>
      )}
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Patient Name</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.patientName}
          onChange={(e) => onChange("patientName", e.target.value)}
          disabled={shouldDisableField("sickLeave", "patientName", formData.patientName)}
          style={getFieldStyle("sickLeave", "patientName", formData.patientName)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>CPR Number</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.cprNumber}
          onChange={(e) => onChange("cprNumber", e.target.value)}
          disabled={shouldDisableField("sickLeave", "cprNumber", formData.cprNumber)}
          style={getFieldStyle("sickLeave", "cprNumber", formData.cprNumber)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Medical Record Number</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.medicalRecordNumber}
          onChange={(e) => onChange("medicalRecordNumber", e.target.value)}
          disabled={shouldDisableField("sickLeave", "medicalRecordNumber", formData.medicalRecordNumber)}
          style={getFieldStyle("sickLeave", "medicalRecordNumber", formData.medicalRecordNumber)}
        />
      </div>

      {/* Patient Status */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Patient Status</h6>
      </div>
      <div className="col-md-6">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={formData.reportedSick}
            onChange={(e) => onChange("reportedSick", e.target.checked)}
          />
          <label className="form-check-label" style={{ fontSize: 12 }}>Reported Sick</label>
        </div>
      </div>

      {/* Consultation Details */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Consultation Details</h6>
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Time of Attend</label>
        <input
          type="time"
          className="form-control form-control-sm"
          value={formData.timeOfAttend}
          onChange={(e) => onChange("timeOfAttend", e.target.value)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Time of Consult</label>
        <input
          type="time"
          className="form-control form-control-sm"
          value={formData.timeOfConsult}
          onChange={(e) => onChange("timeOfConsult", e.target.value)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Consult Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.consultDate}
          onChange={(e) => onChange("consultDate", e.target.value)}
        />
      </div>

      {/* Fitness Assessment */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Fitness Assessment</h6>
      </div>
      <div className="col-md-4">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={formData.patientFitForDuty}
            onChange={(e) => onChange("patientFitForDuty", e.target.checked)}
          />
          <label className="form-check-label" style={{ fontSize: 12 }}>Patient Fit for Duty</label>
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={formData.patientUnfitForDuty}
            onChange={(e) => onChange("patientUnfitForDuty", e.target.checked)}
          />
          <label className="form-check-label" style={{ fontSize: 12 }}>Patient Unfit for Duty</label>
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={formData.advisedLightDuty}
            onChange={(e) => onChange("advisedLightDuty", e.target.checked)}
          />
          <label className="form-check-label" style={{ fontSize: 12 }}>Advised Light Duty</label>
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={formData.patientNeedsEmployeeCare}
            onChange={(e) => onChange("patientNeedsEmployeeCare", e.target.checked)}
          />
          <label className="form-check-label" style={{ fontSize: 12 }}>Patient Needs Employee Care</label>
        </div>
      </div>

      {/* Leave Details */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Leave Details</h6>
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>No. of Days Off (Figures)</label>
        <input
          type="number"
          className="form-control form-control-sm"
          value={formData.noOfDaysOffFigures}
          onChange={(e) => handleDaysFiguresChange(e.target.value)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>No. of Days Off (Words)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.noOfDaysOffWords}
          readOnly
          placeholder="Auto-filled from figures"
          style={{ background: "#FFF8E1" }}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Commencing On</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.commencingOn}
          onChange={(e) => onChange("commencingOn", e.target.value)}
        />
      </div>

      {/* Hospital Admission */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Hospital Admission</h6>
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Admitted On</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.admittedOn}
          onChange={(e) => onChange("admittedOn", e.target.value)}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Discharged On</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.dischargedOn}
          onChange={(e) => onChange("dischargedOn", e.target.value)}
        />
      </div>

      {/* Diagnosis */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Diagnosis</h6>
      </div>
      <div className="col-12">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Diagnosis</label>
        <div className="position-relative">
          <input
            type="text"
            className="form-control form-control-sm"
            value={diagnosisSearch}
            onChange={(e) => onDiagnosisSearchChange(e.target.value)}
            onFocus={() => onDiagnosisDropdownToggle(true)}
            placeholder="Search diagnosis or type manually..."
          />
          {showDiagnosisDropdown && filteredDiagnosisOptions.length > 0 && (
            <div
              className="position-absolute w-100 bg-white border rounded shadow-sm"
              style={{ maxHeight: "200px", overflowY: "auto", zIndex: 1000, top: "100%" }}
            >
              {filteredDiagnosisOptions.map((option, index) => (
                <div
                  key={index}
                  className="p-2 cursor-pointer hover-bg-light" style={{ cursor: "pointer", fontSize: 12 }}
                  style={{ cursor: "pointer" }}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => onDiagnosisSelect(option)}
                >
                  {option.diagnosis_text || option.name || option.diagnosis || "Unknown"}
                </div>
              ))}
            </div>
          )}
        </div>
        <textarea
          className="form-control form-control-sm mt-1"
          rows="2"
          value={formData.diagnosis || ""}
          onChange={(e) => onDiagnosisTextChange(e.target.value)}
          placeholder="Selected diagnoses will appear here (comma-separated)..."
        />
      </div>

      {/* Doctor Information */}
      <div className="col-12 mt-2">
        <h6 className="border-bottom pb-1 mb-1 text-uppercase fw-bold" style={{ fontSize: 12, color: "#7A5C00" }}>Doctor Information</h6>
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Doctor's Name</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.doctorName}
          onChange={(e) => onChange("doctorName", e.target.value)}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>License No.</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.licenseNo}
          onChange={(e) => onChange("licenseNo", e.target.value)}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Specialty</label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={formData.specialty}
          onChange={(e) => onChange("specialty", e.target.value)}
        />
      </div>
      <div className="col-md-6">
        <label className="form-label mb-0" style={{ fontSize: 11 }}>Issue Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={formData.issueDate}
          onChange={(e) => onChange("issueDate", e.target.value)}
        />
      </div>
    </div>
  );
}
